import React from "react"
import ArtworksPage from "../../features/pages/ArtworksPage"
import { getQueryParams } from "../../features/pages/ArtworksPage/utils/mapQueryParams"
import galleryApiService from "../../services/galleryApiService"

const Artworks = ({ catalog, filters }) => {
  return <ArtworksPage catalog={catalog} filters={filters} />
}

export const getServerSideProps = async (ctx) => {
  const filterResponse = await galleryApiService.artworksfilters()
  const response = await galleryApiService.artworks(
    getQueryParams(ctx.query, {}, filterResponse.data),
  )

  return {
    props: {
      catalog: response.data,
      filters: filterResponse.data,
    },
  }
}

export default Artworks
